import { render, staticRenderFns } from "./OuterInnerTable.vue?vue&type=template&id=4f55c0ed&scoped=true"
import script from "./OuterInnerTable.vue?vue&type=script&lang=js"
export * from "./OuterInnerTable.vue?vue&type=script&lang=js"
import style0 from "./OuterInnerTable.vue?vue&type=style&index=0&id=4f55c0ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f55c0ed",
  null
  
)

export default component.exports